import { render, staticRenderFns } from "./ColorGuide.vue?vue&type=template&id=f5e9f3b6"
import script from "./ColorGuide.vue?vue&type=script&lang=js"
export * from "./ColorGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports